import React, { useEffect, useState } from "react";
import ConfirmationModal from "@enerex/unified-ui-react/ConfirmationModal";
import FormInput from "components/FormInput/index";
import { getStateName, getStateId, getStateDisplayName, getAliasStateOptionValue } from "../utilityUtils";
const resolveStateFullName = (row, lookup = []) => {
  const rowStateId = row ? String(getAliasStateOptionValue(row, lookup) ?? "") : "";
  const match = (lookup || []).find((s) => String(getStateId(s) ?? "") === rowStateId);
  const fullName = getStateDisplayName(match) || getStateDisplayName(row) || getStateName(row, lookup) || "";
  return fullName.replace(/[-_]+/g, " ").replace(/\b\w/g, (ch) => ch.toUpperCase());
};

const AliasModal = ({ show, record, onHide, onSave, states, stateLookup = [], saving }) => {
  const [form, setForm] = useState({ StateId: "", StateName: "", Alias: "" });

  useEffect(() => {
    if (!show) return;

    const firstState = record || states?.[0] || null;
    const firstStateId = firstState ? String(getAliasStateOptionValue(firstState, stateLookup) || "") : "";

    setForm({
      Id: record?.id ?? record?.Id ?? 0,
      StateId: firstStateId,
      StateName: resolveStateFullName(firstState, stateLookup),
      Alias: record?.alias || record?.Alias || record?.name || record?.Name || "",
    });
  }, [show, record, states, stateLookup]);

  return (
    <ConfirmationModal
      dialogClassName="modal-md"
      centered
      show={show}
      onHide={onHide}
      title={record ? "Edit Utility Alias" : "Utility Alias"}
      confirmButtonLabel={saving ? "Saving..." : record ? "Save" : "Add Alias"}
      confirmButtonVariant="primary"
      isLoading={saving}
      onConfirm={() => {
        if (!form.StateId || !form.Alias.trim()) return;
        onSave(form);
      }}
    >
        <FormInput
          type="text"
          label={<>Alias <span style={{ color: "#fa5c7c" }}>*</span></>}
          value={form.Alias}
          onChange={(e) => setForm((f) => ({ ...f, Alias: e.target.value }))}
          placeholder="Enter alias"
        />
    </ConfirmationModal>
  );
};

export default AliasModal;

